import {
  Component,
  Input,
  ViewEncapsulation,
  forwardRef,
  signal,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from "@angular/forms";
import { TranslocoPipe } from "@jsverse/transloco";
import { ASSETS_PATH } from "../../constants/app.constants";

import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatNativeDateModule } from "@angular/material/core";
import { MatIconModule } from "@angular/material/icon";
import { provideLuxonDateAdapter } from "@angular/material-luxon-adapter";

export const DATE_FORMAT = {
  parse: {
    dateInput: "dd/MM/yyyy",
  },
  display: {
    dateInput: "dd/MM/yyyy",
    monthYearLabel: "MMM yyyy",
    dateA11yLabel: "DD",
    monthYearA11yLabel: "MMMM yyyy",
  },
};

@Component({
  selector: "er-datepicker",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslocoPipe,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    MatIconModule,
  ],
  templateUrl: "./datepicker.component.html",
  styleUrl: "./datepicker.component.scss",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ErDatepickerComponent),
      multi: true,
    },
    provideLuxonDateAdapter(DATE_FORMAT),
  ],
  encapsulation: ViewEncapsulation.None,
})
export class ErDatepickerComponent implements ControlValueAccessor {
  @Input() placeholder = "";
  @Input() disabled = false;
  @Input() minDate: Date | null = null;
  @Input() maxDate: Date | null = null;
  @Input() label = "";
  @Input() disabledDates: Date[] = [];

  public value = signal<Date | null>(null);
  public touched = false;

  public readonly assetsPath = ASSETS_PATH;

  onChange = (_: any) => {};
  onTouched = () => {};

  public isDateAllowed = (raw: any): boolean => {
    if (!raw) return false;

    const date = raw.toJSDate();

    return !this.disabledDates.some(
      (d) =>
        d.getDate() === date?.getDate() &&
        d.getMonth() === date?.getMonth() &&
        d.getFullYear() === date?.getFullYear(),
    );
  };

  public writeValue(value: Date | null): void {
    this.value.set(value);
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public onValueChange(value: any): void {
    const date = value.toJSDate();
    this.value.set(date);
    this.onChange(date);
    this.markAsTouched();
  }

  public markAsTouched(): void {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }
}
